import type { SxStyle } from '@aibees/shared/theme';

const contentBase: SxStyle = {
  backgroundColor: 'transparent',
  height: (p) => p.spacing(4),
  borderRadius: (p) => p.spacing(0.5),
  color: (p) => p.palette.grey[600],
  alignItems: 'center',
  ':hover': {
    backgroundColor: (p) => p.palette.grey[200],
  },
  '.highlight': {
    backgroundColor: 'transparent',
    fontWeight: 700,
  },
};

export const root: SxStyle = {
  ...contentBase,
  display: 'flex',
  flexDirection: 'row',
  padding: (p) => p.spacing(0, 0.5),
  cursor: 'pointer',
  gap: (p) => p.spacing(1),
  // marginBottom: (p) => p.spacing(0.5),
};

export const checkboxLeftSx: SxStyle = { marginLeft: 0.5 };
